import { render, staticRenderFns } from "./beneficiarioForm.vue?vue&type=template&id=4aeb7cde&scoped=true&"
import script from "./beneficiarioForm.vue?vue&type=script&lang=js&"
export * from "./beneficiarioForm.vue?vue&type=script&lang=js&"
import style0 from "./beneficiarioForm.vue?vue&type=style&index=0&id=4aeb7cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeb7cde",
  null
  
)

export default component.exports